import React from 'react'

const StudentGroupWise = () => {
  return (
    <div>StudentGroupWise</div>
  )
}

export default StudentGroupWise